var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    [_vm.$style.inputField]: true,
    [_vm.$style.flexDisplay] : _vm.config.style && _vm.config.style.flexDisplay,
  }},[_c('span',{class:{
      [_vm.$style.boldLabel] : _vm.config.style && _vm.config.style.boldLabel,
    }},[_vm._v(_vm._s(_vm.config.confirmationText))]),_c('div',{class:_vm.$style.inputContainer},[_c('InputValidator',{class:{
        [_vm.$style.confirmationInput]: true,
        [_vm.$style.confirmationInputWithError]: _vm.v2Errors.items.length,
        [_vm.$style.inputSpacing] : _vm.config.style && _vm.config.style.inputSpacing,
      },attrs:{"config":{
        autocomplete: _vm.config.autocomplete || 'on',
        'data-lpignore': true,
        disabled: _vm.config.disabled,
        errorStyleExceptions: _vm.$style.validationError,
        name: _vm.config.name,
        validate: _vm.config.validationRule,
        value: _vm.defaultValue,
        readonly: _vm.config.readonly,
        type: _vm.config.type || 'text'
      }},on:{"InputValidatorModel":_vm.handleValueChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }